let _ = t => t,
  _t;
import styled from 'styled-components';
import H2 from 'UIComponents/elements/headings/H2';
import UIList from 'UIComponents/list/UIList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE, OLAF } from 'HubStyleTokens/colors';
// @ts-expect-error untyped module
import useMediaQuery from '../hooks/useMediaQuery';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import ACIllustration from 'academy-common-lib/components/illustration/ACIllustration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CertificateTile = styled(UITile).withConfig({
  displayName: "CertificatePreview__CertificateTile",
  componentId: "fsogx-0"
})(["border:none;border-radius:0;background:", ";margin-top:0 !important;color:", ";height:100%;max-height:210px;@media (min-width:850px){height:210px;}"], EERIE, OLAF);
export const ModalTileSection = styled(UITileSection).withConfig({
  displayName: "CertificatePreview__ModalTileSection",
  componentId: "fsogx-1"
})(["", ""], mediaQuery('mobile', css(_t || (_t = _`
      padding-left: 12px;
      padding-right: 12px;
    `))));
const SectionWrapper = styled.div.withConfig({
  displayName: "CertificatePreview__SectionWrapper",
  componentId: "fsogx-2"
})(["display:flex;align-items:center;justify-content:center;margin-bottom:-32px;height:100%;"]);
const CertificateWrapper = styled.div.withConfig({
  displayName: "CertificatePreview__CertificateWrapper",
  componentId: "fsogx-3"
})(["position:relative;height:230px;width:300px;@media (max-width:850px){width:min(100%,300px);}margin-top:-42px;margin-bottom:-42px;z-index:1;"]);
const CertificatePoint = styled(FormattedMessage).withConfig({
  displayName: "CertificatePreview__CertificatePoint",
  componentId: "fsogx-4"
})(["font-weight:400;"]);
const CertificatePreview = ({
  title,
  iconUrl
}) => {
  const isLargerThanModalWidth = useMediaQuery('(min-width: 850px)');
  return /*#__PURE__*/_jsx(CertificateTile, {
    children: /*#__PURE__*/_jsx(ModalTileSection, {
      style: {
        height: '100%'
      },
      children: /*#__PURE__*/_jsxs(SectionWrapper, {
        children: [/*#__PURE__*/_jsx(CertificateWrapper, {
          children: /*#__PURE__*/_jsx(ACIllustration, {
            iconUrl: iconUrl,
            name: "certificate",
            title: title
          })
        }), isLargerThanModalWidth && /*#__PURE__*/_jsxs("div", {
          className: "m-left-6",
          children: [/*#__PURE__*/_jsx(H2, {
            className: "m-bottom-1",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyComponents.certificatePreview.title"
            })
          }), /*#__PURE__*/_jsxs(UIList, {
            style: {
              paddingInlineStart: 30,
              marginBottom: 0
            },
            styled: true,
            children: [/*#__PURE__*/_jsx(CertificatePoint, {
              message: "academyComponents.certificatePreview.point1"
            }), /*#__PURE__*/_jsx(CertificatePoint, {
              message: "academyComponents.certificatePreview.point2"
            })]
          })]
        })]
      })
    })
  });
};
export default CertificatePreview;